/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section6_TitleInputs */

const en_about_section6_title = /** @type {(inputs: About_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who is behind PureJSON`)
};

const ko_about_section6_title = /** @type {(inputs: About_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`누가 만드나요`)
};

const ja_about_section6_title = /** @type {(inputs: About_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`運営者について`)
};

/**
* | output |
* | --- |
* | "Who is behind PureJSON" |
*
* @param {About_Section6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section6_title = /** @type {((inputs?: About_Section6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section6_title(inputs)
	if (locale === "ko") return ko_about_section6_title(inputs)
	return ja_about_section6_title(inputs)
});